import React from "react";
import InfoIcon from "../../../../assets/svgs/common/info.svg";
import type { ICampaignMetricMinimal } from "../../../../types/models/campaign-metric.types";
import millify from "millify";

interface AppProps {
	campaignMetrics: ICampaignMetricMinimal;
}

const StatsHomeDashboardAdminPartial: React.FunctionComponent<AppProps> = ({
	campaignMetrics,
}) => {
	const [data] = React.useState([
		{
			title: "Overall views",
			value: millify(campaignMetrics.totalViews ?? 0),
		},
		{
			title: "Cost per view",
			value: `₹ ${campaignMetrics.costPerView?.toFixed(3) ?? "0.000"}`,
		},
		{
			title: "Overall posts",
			value: millify(campaignMetrics.totalPosts ?? 0),
		},
		{
			title: "Campaign margin",
			value: `₹ ${campaignMetrics.campaignMargin ? campaignMetrics.campaignMargin.toLocaleString() : "-"}`,
		},
	]);

	return (
		<div className="flex items-center gap-10 w-full">
			{data.map((item) => {
				return (
					<div
						key={item.title}
						className="flex flex-col flex-1 bg-statcardbg py-8 pl-6 border border-border rounded-10"
					>
						<p className="flex items-center gap-2 font-semibold text-base text-secondary">
							{item.title} <InfoIcon />
						</p>
						<p className="font-black text-3xl text-primary">{item.value}</p>
					</div>
				);
			})}
		</div>
	);
};

export default StatsHomeDashboardAdminPartial;
